import { useContext } from 'react';
import './Slider.css';
import { SlidesContext } from '../contexts/SlidesContext';
import ReviewFormattedMessage from './ReviewFormattedMessage';

export default function Slider ({index, inputKey, label, isPartOfGroup, changeSliderStatus, stepRange, value}) {
  const { updateValues } = useContext(SlidesContext);
  
  const handleInputChange = (event) => {
    const target = event.target;
    const value = target.value;
    
    isPartOfGroup ?
      //Si c'est un slider qui fait parti d'un groupe
      changeSliderStatus(index, inputKey, value)
    :
      //Si c'est un slider en mode solo 
      updateValues(index, inputKey, value)
  }
    return (
      <div className="Slider">
        <div className="Slider-affirmation">
          <ReviewFormattedMessage descriptor={label}/>
        </div>
        <div className="inputAndLabel">
          <input 
            type="range" 
            className="form-control-range" 
            id="formControlRange" 
            min="-99" 
            max="99" 
            value={value} 
            step={stepRange} 
            onChange={handleInputChange}  
          />
        </div>
      </div>  
    );
}
